// import api from './axiosConfig';
import { tagService } from './tagService';

export const memberService = {
  // Register a new member by associating data with a tag
  registerMember: async (tagId, memberData) => {
    try {
      const response = await tagService.updateTag(tagId, { ...memberData, activo: true });
      return response.data;
    } catch (error) {
      console.error(`Error registering member for tag ${tagId}:`, error);
      throw error;
    }
  },

  // Get all registered members (active tags with data)
  getAllMembers: async () => {
    try {
      const activeTags = await tagService.getActiveTags();
      // Assuming the backend returns the full member data within the tag object when active
      return activeTags
        .filter(tag => tag.activo && tag.nombrePropietario) // Filter for active tags with member data
        .map(tag => ({ ...tag, id: tag._id })); // Map _id to id for frontend consistency
    } catch (error) {
      console.error('Error fetching all members:', error);
      throw error;
    }
  },

  // Get a specific member's data by tag ID
  getMemberByTagId: async (tagId) => {
    try {
      const tag = await tagService.getTagById(tagId);
      if (tag && tag.activo) {
        return { ...tag, id: tag._id }; // Return the tag object which contains member data, map _id to id
      } else {
        return null; // Tag is not active or no member data
      }
    } catch (error) {
      console.error(`Error fetching member for tag ${tagId}:`, error);
      throw error;
    }
  },

  // Update a member's data (updates the associated tag)
  updateMember: async (tagId, memberData) => {
    try {
      const response = await tagService.updateTag(tagId, memberData);
      return response.data;
    } catch (error) {
      console.error(`Error updating member for tag ${tagId}:`, error);
      throw error;
    }
  },

  // Delete a member (deactivates the tag and clears member data)
  deleteMember: async (tagId) => {
    try {
      const response = await tagService.updateTag(tagId, { 
        nombrePropietario: '',
        apellidoPropietario: '',
        nombreMascota: '',
        telefono: '',
        direccion: '',
        email: '',
        activo: false 
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting member for tag ${tagId}:`, error);
      throw error;
    }
  },
};
